import Rating from "@material-ui/lab/Rating";
import React from "react";
import {changeRate} from "../../../actions/actionCreators";
import {connect} from "react-redux";

const mapStateToProps = state => ({...state});

const RatingComponent = (props) => {

    const {
        workerId,
        invoice: {
            rate,
            bill: {
                workers = []
            } = {}
        } = {}
    } = props

    const value = workerId ? workers.find(i => i.id === workerId).rate : rate

    const handleChangeRate = (rate) => changeRate(workerId, rate)

    return <Rating
        key={workerId}
        name={`rating-${workerId}`}
        value={value ?? null}
        style={{fontSize: "1.5rem", padding: "1rem 0"}}
        onChange={(event, newValue) => {
            handleChangeRate(newValue);
        }}
    />
}
export default connect(mapStateToProps)(RatingComponent)